<template>
  <div>
    <!-- <line-chart style="heigth:400px;" v-if="datacollection!=null" :chart-data="datacollection"></line-chart> -->
    <new-quiz
      class="col-lg-12"
      :quiz="quiz"
      v-if="addNewQuiz"
      @close="addNewQuiz = false;loadingQuiz = 0;"
    />

    <a
      v-if="addNewQuiz==false"
      v-on:click="openQuizModal()"
      style="margin-bottom:15px;"
      class="form-control btn btn-default-lms"
    >
      Adicionar avaliação
      <i class="fa fa-plus"></i>
    </a>

    <ul class="exams-list">
      <li v-for="q in quizList" :key="q.id" class="has-answered custom-shadow">
        <div class="exam-info-bar">
          <span class="exam-title">{{q.title}}</span>

          <span class="exam-grade">{{q.moduleName}}</span>

          <toggle-button
            style="margin:auto;"
            :disabled="loadingQuiz==q.id"
            @change="toggle(q)"
            :value="q.isActive"
            :color="{checked: '#4ebcd7', unchecked: '#dc3545'}"
            :width="70"
            :sync="true"
            :labels="{checked: 'Ativo', unchecked: 'Inativo'}"
          />

          <!-- <quiz-button
            v-if="q.isActive"
            class="error"
            @click="toggle(q)"
            :loading="loadingQuiz==q.id"
          >Desativar</quiz-button>
          <quiz-button
            v-else
            class="activate"
            @click="toggle(q)"
            :loading="loadingQuiz==q.id"
          >Ativar</quiz-button>-->

          <!-- <a v-if="q.isActive" @click="toggle(q)" class="error" style="font-size: 13px;">Desativar</a>
          <a v-else @click="toggle(q)" class="activate" style="font-size: 13px;">Ativar</a>-->
          <quiz-button
            class="primary"
            @click="openQuizModal(q)"
            :loading="loadingQuiz==q.id"
          >visualizar</quiz-button>

          <quiz-button class="error" @click="removeQuiz(q)" :loading="loadingQuiz==q.id">Remover</quiz-button>

          <a
            v-if="addNewQuiz==false"
            v-on:click="getAllAnswers(q)"
            style="margin-bottom:15px;"
            class="form-control btn btn-default-lms"
          >
            Correções &nbsp;
            <i class="fa fa-pencil"></i>
          </a>
          <review-quiz
            class="col-lg-12"
            :quizParam="q"
            v-if="showReview"
            @close="showReview = false;"
          />
        </div>
      </li>
    </ul>
  </div>
</template>


<style lang="scss" scoped>
.li-custom {
  grid-template-columns: 0.75fr 0.75fr 0.75fr 1fr 1fr 0.75fr !important;
}

a.disabled {
  pointer-events: none;
  cursor: default;
}
.has-error {
  border-color: #a94442;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
</style>


<script>
import QuizButton from "../../Buttons/QuizButton";
import axios from "axios";
import NewQuiz from "./NewQuiz";
import { mapState } from "vuex";
import ReviewQuiz from "../ReviewQuiz";

axios.defaults.withCredentials = true;

export default {
  data() {
    return {
      loadingQuiz: 0,
      course: this.$store.getters.course,
      addNewQuiz: false,
      unlimited: false,
      newCoupon: {},
      addNew: false,
      datacollection: null,
      showReview: false,
      quizParam: undefined
    };
  },
  computed: mapState(["quizList"]),
  components: {
    QuizButton,
    "new-quiz": NewQuiz,
    "review-quiz": ReviewQuiz
  },
  methods: {
    getAllAnswers(quiz) {
      this.showReview = true;
      this.quizParam = quiz;
      console.log("mandou pegar todas as respostas");
      console.log(this.quizParam);
    },
    removeQuiz(quiz) {
      this.loadingQuiz = quiz.id;
      const path = this.$global.endpoint + "/quiz/remove";
      axios
        .post(path, {
          quizId: quiz.id
        })
        .then(res => {
          this.loadingQuiz = 0;
          this.$store.dispatch("loadQuizList", this.course.id);
        })
        .catch(error => {
          console.error(error);
        });
    },
    toggle(quiz) {
      this.loadingQuiz = quiz.id;
      console.log(quiz.isActive);
      //quiz.isActive = !quiz.isActive;

      let newList = this.quizList.map(function(o) {
        if (o.moduleId == quiz.moduleId) {
          if (o.id == quiz.id) {
            o.isActive = !quiz.isActive;
          } else {
            if (quiz.isActive == false) {
              o.isActive = false;
            }
          }
        }
        return o;
      });

      console.log("newlist: ", newList);

      const path = this.$global.endpoint + "/quiz/savemany";
      axios
        .post(path, {
          quizList: newList
        })
        .then(res => {
          this.loadingQuiz = 0;
          this.$store.dispatch("loadQuizList", this.course.id);
        })
        .catch(error => {
          console.error(error);
        });
    },
    openQuizModal(quiz) {
      if (!quiz) quiz = {};
      this.loadingQuiz = quiz.id;
      this.quiz = quiz;
      this.addNewQuiz = true;
    }
  },
  created() {}
};
</script>
